import { render } from "./PlanetStats.vue?vue&type=template&id=2a1a9b94&scoped=true"
import script from "./PlanetStats.vue?vue&type=script&lang=js"
export * from "./PlanetStats.vue?vue&type=script&lang=js"

import "./PlanetStats.vue?vue&type=style&index=0&id=2a1a9b94&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a1a9b94"]])

export default __exports__